<script lang="ts">
	import { format } from 'svelte-i18n';
	// Design system
	import { BulletedList, Collapse, Loader, Text } from '@Shelly/shelly-design-system/index';
	// Components
	import TemplateInputSettings from './Components/TemplateInputSettings.svelte';
	import TemplateToggleSettings from './Components/TemplateToggleSettings.svelte';
	import TemplateDropdownSettings from './Components/TemplateDropdownSettings.svelte';
	// Helpers
	import { fetchXT1DeviceSettings } from 'src/helpers/xt1_helpers/template_settings_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	// Types
	import type { Device } from 'src/types/Device';

	export let device: Device,
		startOpenIndex: number,
		openIndex: number | null = null;

	const _device = device;
	const getCurrentIndex = (index: number) => {
		return index + startOpenIndex;
	};
</script>

{#await fetchXT1DeviceSettings(_device)}
	<div class="d-flex justify-content-center">
		<Loader />
	</div>
{:then settings}
	{#each settings as { key, view, title, desc, options, type, range }, i}
		{#if key}
			<Collapse
				id="collapse-xt1-settings-{key}"
				title={capFirstChar(
					$format(`label_${(title || key).toLowerCase()}}`, {
						default: (title || key).replace(/_/g, ' '),
					}),
				)}
				class="mb-s"
				expanded={openIndex === getCurrentIndex(i)}
				on:click={() => {
					openIndex = openIndex === getCurrentIndex(i) ? null : getCurrentIndex(i);
				}}
			>
				{#if desc}
					{#if Array.isArray(desc)}
						<BulletedList
							titleClasses="text-normal"
							titleStyleType="body-extra-small"
							class="mb-s"
							list={desc}
						/>
					{:else}
						<Text class="mb-s" styleType="body-small" size="s" slot="description"
							>{$format(`label_${key.toLowerCase()}_desc`, {
								default: desc,
							})}</Text
						>
					{/if}
				{/if}
				{#if type === 'boolean'}
					<TemplateToggleSettings
						{device}
						setting={key}
						title={$format('enable', {
							default: 'Enable',
						})}
					/>
				{:else if type === 'number'}
					<TemplateInputSettings
						{device}
						setting={key}
						min={range?.min ?? 0}
						max={range?.max ?? 100}
						withCheckbox
					/>
				{:else if Array.isArray(options)}
					<TemplateDropdownSettings {device} setting={key} {options} />
				{/if}
			</Collapse>
		{/if}
	{/each}
{/await}
